module.exports = __webpack_public_path__ + "static/img/07.a7f6d27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/raz_frauenfeld/07.jpg
// module id = 446
// module chunks = 1